<template>
  <div
    id="devmg"
    v-loading.fullscreen.lock="loading"
    element-loading-text="Waiting...."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >

    <div class="demo-image">
      <el-button type="primary" @click="open_add_lunboxinxi" >添加轮播信息</el-button>
      <div class="block" v-for="fit in fits" >

        <h3 v-if="fit.type == 'info'"> 滚动公告：</h3>
        <span class="demonstration">{{ fit.title }}</span> <br><br/>
        <el-image  v-if="fit.type == 'image'"
          style="width: 960px; height: 480px"
          :src="fit.url"
          ></el-image>
        <br/>
        <el-button type="primary" @click="Delete_swap(fit.id)"  v-if="fit.type == 'image'" >删除</el-button>
        <el-divider></el-divider>
      </div>
    </div>
    <el-dialog title="添加轮播信息" :visible.sync="dialogFormVisible">
      <span> Step 1:</span>
      <div>
        <el-input placeholder="输入该轮播对应的描述" v-model="lunbotext" maxlength="50" show-word-limit>
          <template slot="prepend">描述：</template>
        </el-input>
      </div>
      <span> Step 2:</span>
      <el-upload
        :file-list="fileList"
        action="/user/swapupload"
        accept="image/jpeg"
        :on-success="handleAvatarSuccess"
        :on-error="uploadError"
        :before-upload="beforeAvatarUpload"
        list-type="picture-card"
        :limit="1"
        :data="uploaddata"
        >

        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
      </el-upload>
      <br>


      <div slot="footer" class="dialog-footer" >
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
</div>
</template>
<style scoped>
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    #devmg {
      padding-top: 20px;
      width: 100%;
      text-align:left ;
    }
    .demonstration{
      font-family: Georgia, '宋体', Times, serif;
    }
    .demo-image {
      margin: 20px ;
    }
    .demo-image .block{
       margin: 30px;
    }
    .el-table {
      margin: 20px ;
    }
    .el-table .warning-row {
      background: oldlace;
    }

    .el-table .success-row {
      background: #f0f9eb;
    }
    .edit_dev  {
      text-align:left ;
      /deep/ .el-transfer-panel {
        width:300px;
      }
    }
</style>

<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type":"application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      loading :false,
      devkindkind:0,
      fits: [ ],
      dialogFormVisible:false,
      action_upload:"/user/swapupload",
      falses:false,
      jpgname:"",
      jpglocalurl:"",
      fileList: [],
      uploaddata:{},
      jpg:{},
      lunbotext:""
    };
  },
  created(){
    this.get_swap_info();
    //this.action_upload = "";
  },
  methods: {
    uploadError(er){
      console.log(er);
    },

    handleAvatarSuccess(res, file) {
        this.dialogFormVisible = false;
        this.get_swap_info();
    },
    beforeAvatarUpload(file){
          var fileName = new Array();
          fileName = file.name.split(".");
          this.uploaddata.id =  sessionStorage.getItem("id");
          this.uploaddata.token = sessionStorage.getItem("token");//name
          this.uploaddata.name = file.name;
          this.uploaddata.type = "image";
          this.uploaddata.to = "#";
          const extension =  fileName[fileName.length - 1] === "jpg";
          const extension2 = fileName[fileName.length - 1] === "JPG";
          if (!extension && !extension2) {
            this.$message({
              message: "上传文件只能是jpg格式!",
              type: "warning"
            });
            return false;
          }
          if(this.lunbotext===""){
            this.$message({
              type: 'info',
              message: '轮播描述没有填写'
            });
            return false;
          }
          this.uploaddata.lunbotext = this.lunbotext;
            const isJPG = file.type === 'image/jpeg';
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isJPG) {
              this.$message.error('上传头像图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
              this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
    },
    open_add_lunboxinxi(){
      this.jpgname="";
      this.lunbotext="";
      this.fileList=[];
      this.dialogFormVisible = true;
    },
    Delete_swap(id){
      this.$confirm('此操作将永久删除该展览信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.Delete_swap_(id);
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                });
              });
    },
    Delete_swap_(id){
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      data.append("swapid", id);
      axios
        .post("/user/fnckukei/delete_swapinfo", data)
        .then(
          function(res) {
            if (res.data.res) {
                console.log(res.data);
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.get_swap_info();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    get_swap_info(){
      ///user/fnckukei/getswapinfo
      let data = new FormData();
      data.append("id", sessionStorage.getItem("id"));
      data.append("token", sessionStorage.getItem("token"));
      axios
        .post("/user/fnckukei/getswapinfo", data)
        .then(
          function(res) {
            if (res.data.res) {
                console.log(res.data);
                this.fits = res.data.data;
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });

    },
    get_file_list() {
      axios
        .get("/Get_file_List_val.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd"),
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.file;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/xxxvue/admin_zhanlan.vue